import { WEB_COMPONENT_SENSOR_AZURE_AD } from '../../../webcomponents.constants';
import { AzureADSensorComponent } from './component/AzureADSensorComponent';

export { AzureADSensorComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_AZURE_AD, AzureADSensorComponent);
